__turbopack_context__.v({
  "decision": "sgJQ1q_decision",
  "demo": "sgJQ1q_demo",
  "diagram": "sgJQ1q_diagram",
  "distance": "sgJQ1q_distance",
  "distanceNote": "sgJQ1q_distanceNote",
  "distanceScale": "sgJQ1q_distanceScale",
  "endpoint": "sgJQ1q_endpoint",
  "exampleSelect": "sgJQ1q_exampleSelect",
  "flow": "sgJQ1q_flow",
  "flowNumber": "sgJQ1q_flowNumber",
  "flows": "sgJQ1q_flows",
  "intro": "sgJQ1q_intro",
  "join": "sgJQ1q_join",
  "json": "sgJQ1q_json",
  "metrics": "sgJQ1q_metrics",
  "note": "sgJQ1q_note",
  "photo": "sgJQ1q_photo",
  "photoBranch": "sgJQ1q_photoBranch",
  "photos": "sgJQ1q_photos",
  "representStep": "sgJQ1q_representStep",
  "representation": "sgJQ1q_representation",
  "result": "sgJQ1q_result",
  "resultHeader": "sgJQ1q_resultHeader",
  "reveal": "sgJQ1q_reveal",
  "saved": "sgJQ1q_saved",
  "signal": "sgJQ1q_signal",
  "stepLabel": "sgJQ1q_stepLabel",
  "threshold": "sgJQ1q_threshold",
  "transform": "sgJQ1q_transform",
  "vector": "sgJQ1q_vector",
  "vectorGrid": "sgJQ1q_vectorGrid",
  "vectorLabel": "sgJQ1q_vectorLabel",
  "vectorValues": "sgJQ1q_vectorValues",
  "workspace": "sgJQ1q_workspace",
});
